import React from 'react'
import { ReactComponent as PlusIcon } from 'images/competitor-pricing/plus.svg'
import { ReactComponent as MinusIcon } from 'images/competitor-pricing/minus.svg'
import { PriceChangeActions } from 'components/station/components/competitor-pricing/context/constants'
import PropTypes from 'prop-types'

const PriceButton = ({
  setManualInputEnabled,
  dispatch,
  minus,
  fuelGradeId,
  pricingType,
  pendingRequest
}) => {
  const Icon = minus ? MinusIcon : PlusIcon
  const type = minus
    ? PriceChangeActions.DecrementPrice
    : PriceChangeActions.IncrementPrice

  const handleClick = () => {
    // Prevent negative prices
    if(minus && pendingRequest?.newPrice < 1){return}
    
    setManualInputEnabled(false)
    dispatch({
      type,
      payload: {
        fuelGradeId,
        pricingType,
      },
    })
  }

  return (
    <Icon
      height={16}
      width={16}
      onClick={handleClick}
      data-testid="price-button"
    />
  )
}

PriceButton.propTypes = {
  setManualInputEnabled: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  minus: PropTypes.bool,
  fuelGradeId: PropTypes.string.isRequired,
  pricingType: PropTypes.string.isRequired,
  pendingRequest: PropTypes.oneOfType([
    PropTypes.shape({
      price: PropTypes.number.isRequired,
      newPrice: PropTypes.number.isRequired,
      fuelGradeId: PropTypes.string.isRequired,
      pricingType: PropTypes.string.isRequired,
      stationId: PropTypes.string.isRequired,
    }),
    PropTypes.oneOf([null]),
  ]).isRequired,
}

PriceButton.defaultProps = {
  setManualInputEnabled: () => {},
  minus: false,
}

export { PriceButton }
